import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import { RESET_AMWELL_ACTIVITY } from '../actions';
import { HealthDocumentRecord } from './types';
import * as actions from './actions';

type Operations = 'get' | 'search' | 'add' | 'remove';

export type HealthDocumentsState = Readonly<{
  data: HealthDocumentRecord[];
  loading: Record<Operations, boolean>;
  errors: Record<Operations, Nullable<Error>>;
}>;

export const healthDocumentsInitialState: HealthDocumentsState = {
  data: [],
  loading: {
    get: false,
    search: false,
    add: false,
    remove: false
  },
  errors: {
    get: null,
    search: null,
    add: null,
    remove: null
  }
};

export const healthDocumentsReducer = createReducer(healthDocumentsInitialState, {
  [actions.GET_HEALTH_DOCUMENTS]: state => {
    state.loading.get = true;
    state.errors.get = null;
  },
  [actions.GET_HEALTH_DOCUMENTS_FAIL]: (state, action) => {
    state.errors.get = action.error;
    state.loading.get = false;
  },
  [actions.GET_HEALTH_DOCUMENTS_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.get = false;
  },
  [actions.SEARCH_HEALTH_DOCUMENTS]: state => {
    state.loading.search = true;
    state.errors.search = null;
  },
  [actions.SEARCH_HEALTH_DOCUMENTS_FAIL]: (state, action) => {
    state.errors.search = action.error;
    state.loading.search = false;
  },
  [actions.SEARCH_HEALTH_DOCUMENTS_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.search = false;
  },
  [actions.ADD_HEALTH_DOCUMENT]: state => {
    state.errors.add = null;
    state.loading.add = true;
  },
  [actions.ADD_HEALTH_DOCUMENT_FAIL]: (state, action) => {
    state.errors.add = action.error;
    state.loading.add = false;
  },
  [actions.ADD_HEALTH_DOCUMENT_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.add = false;
  },
  [actions.UPLOAD_CONSUMER_IMAGE]: state => {
    state.errors.add = null;
    state.loading.add = true;
  },
  [actions.UPLOAD_CONSUMER_IMAGE_FAIL]: (state, action) => {
    state.errors.add = action.error;
    state.loading.add = false;
  },
  [actions.UPLOAD_CONSUMER_IMAGE_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.add = false;
  },
  [actions.REMOVE_HEALTH_DOCUMENT]: state => {
    state.errors.remove = null;
    state.loading.remove = true;
  },
  [actions.REMOVE_HEALTH_DOCUMENT_FAIL]: (state, action) => {
    state.errors.remove = action.error;
    state.loading.remove = false;
  },
  [actions.REMOVE_HEALTH_DOCUMENT_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.remove = false;
  },
  [RESET_AMWELL_ACTIVITY]: () => healthDocumentsInitialState
});
